export const EDIT_ADMIN_MANUAL_OPPORTUNITY_INIT_VALUES = {
	user: null,
	endTime: '',
	imagePath: '',
	filePathes: [],
	gender: undefined,
	opportunityName: '',
	isApprovalRequired: false,
	opportunityDescription: '',
	withWho: [],
};
